import { useQuery } from '@tanstack/react-query';
import { SonarApi } from 'osep-generator-service-client-v1';
import { SONAR_PERMISSION_GROUPS } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useSonarPermissionGroups() {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [SONAR_PERMISSION_GROUPS],
    queryFn: async () => {
      const config = await getApiConfig();
      return new SonarApi(config, undefined, axiosInstance)
        .getSonarPermissionTemplates()
        .then((response) => response.data);
    },
  });
}

export default useSonarPermissionGroups;
